import React, { FC, memo } from 'react'
import { ListWrapper, FooterGroupList, Slide, Title, FooterList } from './styles'
import ExternalLink from '../external-link'
import FooterSectionTransport from '../../../transports/common/footer-section-transport'

interface FooterLinksContentProps {
    footerGroups: FooterSectionTransport['footerGroups']
}

const FooterLinksContent: FC<FooterLinksContentProps> = ({ footerGroups }) => {
    return (
        <FooterList>
            {footerGroups.map(item => (
                <ListWrapper key={item.groupName}>
                    <FooterGroupList>
                        <li>
                            <Title>{item.groupName}</Title>
                        </li>
                        {item.footerLinkItems.map(footerLinkItem => (
                            <li key={footerLinkItem.text}>
                                <ExternalLink
                                    as={Slide}
                                    title={footerLinkItem.text}
                                    href={footerLinkItem.url}
                                    noCrawl={footerLinkItem.noCrawl}
                                >
                                    {footerLinkItem.text}
                                </ExternalLink>
                            </li>
                        ))}
                    </FooterGroupList>
                </ListWrapper>
            ))}
        </FooterList>
    )
}

export default memo(FooterLinksContent)
